// extracted by mini-css-extract-plugin
export default {"settingTabContainer":"settingTabContainer-c44z734W","icon":"icon-Adep3z33"};